import {useRouter} from 'next/router';
import {pathOr} from 'ramda';
import {useCallback} from 'react';
import {useDispatch, useSelector} from 'react-redux';

import {ROLES_NAMES} from '@/src/app/constants/roles';
import useRoutePaths from '@/src/hooks/useRoutePaths';

import {COURSE_PREVIEW_PAGE} from '../../constants/pagesTypes';
import getRootServerUrl from '../../utils/getRootServerUrl';
import transforCoursesData from '../../utils/transforCoursesData';
import {
  selectContentCreatorWidget,
  setContentCreator as setContentCreatorAction,
  setContentCreatorCourses,
  setIsContentCreatorFollowed,
} from './contentCreatorWidgetSlice';

const prepareContentCreator = (user) => {
  const isClinic = user.user.type === ROLES_NAMES.CLINIC;

  const clinicImage = user?.clinic?.picture
    ? `${getRootServerUrl()}/${pathOr('', ['clinic', 'picture'], user)}`
    : null;
  const userImage = user?.profile?.picture
    ? `${getRootServerUrl()}/${pathOr('', ['profile', 'picture'], user)}`
    : null;

  return {
    isClinic,
    id: isClinic
      ? pathOr('', ['clinic', 'id'], user)
      : pathOr('', ['id'], user),
    isFollowed: pathOr(false, ['is_followed'], user),
    name: isClinic
      ? pathOr('', ['clinic', 'organization_name'], user)
      : `${pathOr('', ['user', 'first_name'], user)} ${pathOr(
          '',
          ['user', 'last_name'],
          user
        )}`,
    rating: pathOr(0, ['average_score'], user),
    image: isClinic ? clinicImage : userImage,
    about: isClinic
      ? pathOr('', ['clinic', 'description'], user)
      : pathOr('', ['profile', 'biography'], user),
    slug: isClinic
      ? pathOr('', ['clinic', 'slug'], user)
      : pathOr('', ['user', 'username'], user),
  };
};

const useCourseDetailsActions = () => {
  const dispatch = useDispatch();
  const {
    push,
    query: {slug},
    locale,
  } = useRouter();
  const {SIGN_IN_ROUTE} = useRoutePaths();

  const {contentCreator, courses} = useSelector(selectContentCreatorWidget);

  const redirectToLoginPageWithReturn = useCallback(() => {
    push({
      pathname: SIGN_IN_ROUTE.getLink(),
      query: {redirectPage: COURSE_PREVIEW_PAGE, redirectPageId: slug},
    });
  }, [slug]);

  const setCourses = (courses) => {
    dispatch(
      setContentCreatorCourses(
        transforCoursesData(courses.data, locale).filter((course) =>
          Boolean(course.id)
        )
      )
    );
  };

  const setContentCreator = (user) => {
    dispatch(setContentCreatorAction(prepareContentCreator(user)));
  };

  const toggleContentCreatorFollow = (isFollowUpdated) => {
    dispatch(setIsContentCreatorFollowed(isFollowUpdated));
  };

  return {
    setContentCreator,
    contentCreator,
    courses,
    redirectToLoginPageWithReturn,
    setCourses,
    toggleContentCreatorFollow,
  };
};

export default useCourseDetailsActions;
